module.exports = __webpack_public_path__ + "static/img/lbwz.ff92a78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lbwz.png
// module id = et3z
// module chunks = 15